import { Color, Spacing } from '@persona-id/design-tokens';
import { Link } from 'react-router-dom-v5-compat';
import styled from 'styled-components';

import CaseStatusSticker from 'dashboard/components/CaseStatusSticker';
import { userDisplayName } from 'dashboard/lib/valueDisplayers/userDisplayName';
import { Case } from 'dashboard/models/case';
import { User } from 'dashboard/models/user';
import Card from 'design-system/components/Card';

const CasesContainer = styled('div')`
  display: grid;
  grid-template-columns: 1fr;
`;

const CaseRow = styled('div')`
  display: grid;
  grid-template-columns: 1fr;
  grid-column-gap: ${Spacing[2]};

  border-bottom: 1px solid ${Color.CoreSlate50};
  margin-top: ${Spacing[2]};
  padding-bottom: ${Spacing[2]};
`;

const NameContainer = styled('div')`
  display: flex;
  flex-direction: row;
`;

const StyledLink = styled(Link)`
  text-decoration: underline;
  margin-right: ${Spacing[2]};
  white-space: nowrap;
`;

const TextContainer = styled('div')`
  color: ${({ theme }) => theme.color.text.tertiary};
`;

interface CasesSummaryProps {
  cases: Case[];
  users: User[];
  nullStateText: string;
}

const CasesSummary = ({ cases, users, nullStateText }: CasesSummaryProps) => {
  const title = `Cases (${cases.length})`;
  const caseRows = cases.map((kase) => {
    const assignee = users.find((user) => user.id === kase.relationships.assignee?.data?.id);
    const assigneeName = userDisplayName(assignee) || 'Unassigned';

    return (
      <CaseRow key={kase.id}>
        <NameContainer>
          <StyledLink
            to={`/dashboard/cases/${kase.id}`}
            data-test={`cases-summary__case-link--${kase.id}`}
          >
            {kase.attributes.name}
          </StyledLink>
          <CaseStatusSticker caseState={kase.attributes.state} />
        </NameContainer>
        <TextContainer>{assigneeName}</TextContainer>
      </CaseRow>
    );
  });
  return (
    <Card data-test='cases-summary'>
      <Card.Body>
        <Card.Title data-test='cases-summary__title'>{title}</Card.Title>
        <CasesContainer>
          {cases.length > 0 ? <>{caseRows}</> : <TextContainer>{nullStateText}</TextContainer>}
        </CasesContainer>
      </Card.Body>
    </Card>
  );
};

export default CasesSummary;
